import * as PropTypes from 'prop-types';
import React, { useEffect, useState, useMemo } from 'react';
// import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoadingView from './LoadingView';

const NativeAppAutoRedirect = ({
  setRedirectChecked,
  desktopRedirectRoute,
  mobileRedirectRoute,
}) => {
  const { t } = useTranslation('components');
  const [redirectUrl, setRedirect] = useState(false);

  const isDesktopApp = useMemo(() => !!window.top.electron, []);
  const isMobileApp = useMemo(() => !!window.top.flutter_inappwebview, []);

  useEffect(() => {
    if (isDesktopApp && desktopRedirectRoute) {
      setRedirect(desktopRedirectRoute);
    } else if (isMobileApp && mobileRedirectRoute) {
      setRedirect(mobileRedirectRoute);
    } else {
      setRedirectChecked(true);
    }
  }, [desktopRedirectRoute, mobileRedirectRoute, isMobileApp, isDesktopApp, setRedirectChecked]);

  useEffect(() => {
    if (redirectUrl) window.location.href = redirectUrl;
  }, [redirectUrl]);

  return (
    <LoadingView
      title={t('UserManager.LoadingView.title')}
      message={t('UserManager.LoadingView.message')}
    />
  );
};

NativeAppAutoRedirect.propTypes = {
  desktopRedirectRoute: PropTypes.string,
  mobileRedirectRoute: PropTypes.string,
  setRedirectChecked: PropTypes.func.isRequired,
};

NativeAppAutoRedirect.defaultProps = {
  desktopRedirectRoute: '',
  mobileRedirectRoute: '',
};

export default NativeAppAutoRedirect;
